export default "/images/dbbabfcb9b47b16aa3ef7601bd672bc7.png";